import { render, staticRenderFns } from "./AsignaturaEditar.vue?vue&type=template&id=18b4ca08"
import script from "./AsignaturaEditar.vue?vue&type=script&lang=js"
export * from "./AsignaturaEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports